import {
  useMutation,
  useQuery,
  UseMutationOptions,
  UseQueryOptions,
} from '@tanstack/react-query';
import { amplifyFetcher } from '../lib/fetcher';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AWSDate: { input: any; output: any };
  AWSDateTime: { input: any; output: any };
  AWSEmail: { input: any; output: any };
  AWSIPAddress: { input: any; output: any };
  AWSJSON: { input: any; output: any };
  AWSPhone: { input: any; output: any };
  AWSTime: { input: any; output: any };
  AWSTimestamp: { input: any; output: any };
  AWSURL: { input: any; output: any };
  BigInt: { input: any; output: any };
  Double: { input: any; output: any };
};

export type AmplifyAiConversationTurnErrorInput = {
  errorType: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type CheckThenCreateEc2ConfigInput = {
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lab: Lab;
  skipCfn: Scalars['Boolean']['input'];
  terminateTimestamp: Scalars['AWSTimestamp']['input'];
  userId: Scalars['String']['input'];
};

export type CreateEc2ConfigInput = {
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lab: Lab;
  labStatus?: InputMaybe<LabStatus>;
  simulateCreationError?: InputMaybe<Scalars['Boolean']['input']>;
  skipCfn: Scalars['Boolean']['input'];
  terminateTimestamp: Scalars['AWSTimestamp']['input'];
  userId: Scalars['String']['input'];
};

export type CreateLabDetailHistoryInput = {
  creationTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  labDetailHistoryId?: InputMaybe<Scalars['ID']['input']>;
  timeEnded?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  timeStarted?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  ttl: Scalars['AWSTimestamp']['input'];
  userId: Scalars['String']['input'];
};

export type CreateLabDetailInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  lab: Lab;
  lastCreationTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  lastDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  lastTimeEnded?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  lastTimeStarted?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type CreateMessageInput = {
  authorId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CreatePostInput = {
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type CreateUserInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  kontingentCurrent: Scalars['Int']['input'];
  kontingentStartDate: Scalars['AWSTimestamp']['input'];
  userId: Scalars['String']['input'];
};

export type DeleteEc2ConfigInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLabDetailHistoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLabDetailInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMessageInput = {
  id: Scalars['ID']['input'];
};

export type DeletePostInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserInput = {
  id: Scalars['ID']['input'];
};

export type Ec2 = {
  __typename?: 'Ec2';
  id: Scalars['ID']['output'];
  lab: Lab;
  name: Scalars['String']['output'];
  ovpnKey?: Maybe<Scalars['String']['output']>;
  privateKey?: Maybe<Scalars['String']['output']>;
  publicDnsName?: Maybe<Scalars['String']['output']>;
  state: State;
  userId: Scalars['String']['output'];
};

export type Ec2Config = {
  __typename?: 'Ec2Config';
  createdAt: Scalars['AWSDateTime']['output'];
  finished?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lab: Lab;
  labStatus?: Maybe<LabStatus>;
  owner?: Maybe<Scalars['String']['output']>;
  simulateCreationError?: Maybe<Scalars['Boolean']['output']>;
  skipCfn: Scalars['Boolean']['output'];
  terminateTimestamp: Scalars['AWSTimestamp']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum Lab {
  Aufgaben = 'AUFGABEN',
  Bremenhacklab = 'BREMENHACKLAB',
  Dirtypipe = 'DIRTYPIPE',
  Dvl = 'DVL',
  Ec2 = 'EC2',
  Enumnfs = 'ENUMNFS',
  Hackroom1 = 'HACKROOM1',
  Hackroom2 = 'HACKROOM2',
  Hackroom3 = 'HACKROOM3',
  Hackroom4 = 'HACKROOM4',
  Hackroom5 = 'HACKROOM5',
  Kalipurple = 'KALIPURPLE',
  Kaliwin = 'KALIWIN',
  Mimikatz = 'MIMIKATZ',
  Multi = 'MULTI',
  Networkpruefung = 'NETWORKPRUEFUNG',
  Nmap = 'NMAP',
  Password = 'PASSWORD',
  Preparelab = 'PREPARELAB',
  Ssh = 'SSH',
  Vhackroom1 = 'VHACKROOM1',
  Vhackroom2 = 'VHACKROOM2',
  Vhackroom3 = 'VHACKROOM3',
  Vhackroom4 = 'VHACKROOM4',
  Vhackroom5 = 'VHACKROOM5',
  Webinar1 = 'WEBINAR1',
  Webinar2 = 'WEBINAR2',
  Webinar3 = 'WEBINAR3',
  Webinarlab = 'WEBINARLAB',
  Webpruefung = 'WEBPRUEFUNG',
  Winad = 'WINAD',
  Winad2 = 'WINAD2',
  Winadempire = 'WINADEMPIRE',
  Winadmimi = 'WINADMIMI',
}

export type LabDetail = {
  __typename?: 'LabDetail';
  createdAt: Scalars['AWSDateTime']['output'];
  history?: Maybe<ModelLabDetailHistoryConnection>;
  id: Scalars['ID']['output'];
  lab: Lab;
  lastCreationTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  lastDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  lastTimeEnded?: Maybe<Scalars['AWSTimestamp']['output']>;
  lastTimeStarted?: Maybe<Scalars['AWSTimestamp']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type LabDetailHistoryArgs = {
  filter?: InputMaybe<ModelLabDetailHistoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type LabDetailHistory = {
  __typename?: 'LabDetailHistory';
  createdAt: Scalars['AWSDateTime']['output'];
  creationTimeInSeconds?: Maybe<Scalars['Int']['output']>;
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  labDetailHistoryId?: Maybe<Scalars['ID']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  timeEnded?: Maybe<Scalars['AWSTimestamp']['output']>;
  timeStarted?: Maybe<Scalars['AWSTimestamp']['output']>;
  ttl: Scalars['AWSTimestamp']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['String']['output'];
};

export enum LabStatus {
  Created = 'CREATED',
  CreateFailed = 'CREATE_FAILED',
  CreateInProgress = 'CREATE_IN_PROGRESS',
  DeleteInProgress = 'DELETE_IN_PROGRESS',
  UpdateInProgress = 'UPDATE_IN_PROGRESS',
}

export type Message = {
  __typename?: 'Message';
  authorId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum ModelAttributeTypes {
  Null = '_null',
  Binary = 'binary',
  BinarySet = 'binarySet',
  Bool = 'bool',
  List = 'list',
  Map = 'map',
  Number = 'number',
  NumberSet = 'numberSet',
  String = 'string',
  StringSet = 'stringSet',
}

export type ModelBooleanInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelEc2ConfigConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelEc2ConfigConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  finished?: InputMaybe<ModelBooleanInput>;
  lab?: InputMaybe<ModelLabInput>;
  labStatus?: InputMaybe<ModelLabStatusInput>;
  not?: InputMaybe<ModelEc2ConfigConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelEc2ConfigConditionInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  simulateCreationError?: InputMaybe<ModelBooleanInput>;
  skipCfn?: InputMaybe<ModelBooleanInput>;
  terminateTimestamp?: InputMaybe<ModelIntInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelStringInput>;
};

export type ModelEc2ConfigConnection = {
  __typename?: 'ModelEc2ConfigConnection';
  items: Array<Maybe<Ec2Config>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelEc2ConfigFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelEc2ConfigFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  finished?: InputMaybe<ModelBooleanInput>;
  id?: InputMaybe<ModelIdInput>;
  lab?: InputMaybe<ModelLabInput>;
  labStatus?: InputMaybe<ModelLabStatusInput>;
  not?: InputMaybe<ModelEc2ConfigFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelEc2ConfigFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  simulateCreationError?: InputMaybe<ModelBooleanInput>;
  skipCfn?: InputMaybe<ModelBooleanInput>;
  terminateTimestamp?: InputMaybe<ModelIntInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelStringInput>;
};

export type ModelFloatInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelIdInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<ModelSizeInput>;
};

export type ModelIntInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelLabDetailConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLabDetailConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  lab?: InputMaybe<ModelLabInput>;
  lastCreationTimeInSeconds?: InputMaybe<ModelIntInput>;
  lastDurationInSeconds?: InputMaybe<ModelIntInput>;
  lastTimeEnded?: InputMaybe<ModelIntInput>;
  lastTimeStarted?: InputMaybe<ModelIntInput>;
  not?: InputMaybe<ModelLabDetailConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLabDetailConditionInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelLabDetailConnection = {
  __typename?: 'ModelLabDetailConnection';
  items: Array<Maybe<LabDetail>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLabDetailFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLabDetailFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  lab?: InputMaybe<ModelLabInput>;
  lastCreationTimeInSeconds?: InputMaybe<ModelIntInput>;
  lastDurationInSeconds?: InputMaybe<ModelIntInput>;
  lastTimeEnded?: InputMaybe<ModelIntInput>;
  lastTimeStarted?: InputMaybe<ModelIntInput>;
  not?: InputMaybe<ModelLabDetailFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLabDetailFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelLabDetailHistoryConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLabDetailHistoryConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  creationTimeInSeconds?: InputMaybe<ModelIntInput>;
  durationInSeconds?: InputMaybe<ModelIntInput>;
  labDetailHistoryId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelLabDetailHistoryConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLabDetailHistoryConditionInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  timeEnded?: InputMaybe<ModelIntInput>;
  timeStarted?: InputMaybe<ModelIntInput>;
  ttl?: InputMaybe<ModelIntInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelStringInput>;
};

export type ModelLabDetailHistoryConnection = {
  __typename?: 'ModelLabDetailHistoryConnection';
  items: Array<Maybe<LabDetailHistory>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelLabDetailHistoryFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelLabDetailHistoryFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  creationTimeInSeconds?: InputMaybe<ModelIntInput>;
  durationInSeconds?: InputMaybe<ModelIntInput>;
  id?: InputMaybe<ModelIdInput>;
  labDetailHistoryId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelLabDetailHistoryFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelLabDetailHistoryFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  timeEnded?: InputMaybe<ModelIntInput>;
  timeStarted?: InputMaybe<ModelIntInput>;
  ttl?: InputMaybe<ModelIntInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelStringInput>;
};

export type ModelLabInput = {
  eq?: InputMaybe<Lab>;
  ne?: InputMaybe<Lab>;
};

export type ModelLabStatusInput = {
  eq?: InputMaybe<LabStatus>;
  ne?: InputMaybe<LabStatus>;
};

export type ModelMessageConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMessageConditionInput>>>;
  authorId?: InputMaybe<ModelStringInput>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelMessageConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMessageConditionInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelMessageConnection = {
  __typename?: 'ModelMessageConnection';
  items: Array<Maybe<Message>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMessageFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelMessageFilterInput>>>;
  authorId?: InputMaybe<ModelStringInput>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelMessageFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMessageFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelPostConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPostConditionInput>>>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelPostConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPostConditionInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  title?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  username?: InputMaybe<ModelStringInput>;
};

export type ModelPostConnection = {
  __typename?: 'ModelPostConnection';
  items: Array<Maybe<Post>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPostFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPostFilterInput>>>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelPostFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPostFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  title?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  username?: InputMaybe<ModelStringInput>;
};

export type ModelSizeInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export enum ModelSortDirection {
  Asc = 'ASC',
  Desc = 'DESC',
}

export type ModelStringInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<ModelSizeInput>;
};

export type ModelSubscriptionBooleanInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelSubscriptionEc2ConfigFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionEc2ConfigFilterInput>>>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  finished?: InputMaybe<ModelSubscriptionBooleanInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  lab?: InputMaybe<ModelSubscriptionStringInput>;
  labStatus?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionEc2ConfigFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  simulateCreationError?: InputMaybe<ModelSubscriptionBooleanInput>;
  skipCfn?: InputMaybe<ModelSubscriptionBooleanInput>;
  terminateTimestamp?: InputMaybe<ModelSubscriptionIntInput>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
  userId?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionFloatInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type ModelSubscriptionIdInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ModelSubscriptionIntInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ModelSubscriptionLabDetailFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionLabDetailFilterInput>>>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  lab?: InputMaybe<ModelSubscriptionStringInput>;
  labDetailHistoryId?: InputMaybe<ModelSubscriptionIdInput>;
  lastCreationTimeInSeconds?: InputMaybe<ModelSubscriptionIntInput>;
  lastDurationInSeconds?: InputMaybe<ModelSubscriptionIntInput>;
  lastTimeEnded?: InputMaybe<ModelSubscriptionIntInput>;
  lastTimeStarted?: InputMaybe<ModelSubscriptionIntInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionLabDetailFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionLabDetailHistoryFilterInput = {
  and?: InputMaybe<
    Array<InputMaybe<ModelSubscriptionLabDetailHistoryFilterInput>>
  >;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  creationTimeInSeconds?: InputMaybe<ModelSubscriptionIntInput>;
  durationInSeconds?: InputMaybe<ModelSubscriptionIntInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  or?: InputMaybe<
    Array<InputMaybe<ModelSubscriptionLabDetailHistoryFilterInput>>
  >;
  owner?: InputMaybe<ModelStringInput>;
  timeEnded?: InputMaybe<ModelSubscriptionIntInput>;
  timeStarted?: InputMaybe<ModelSubscriptionIntInput>;
  ttl?: InputMaybe<ModelSubscriptionIntInput>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
  userId?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionMessageFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionMessageFilterInput>>>;
  authorId?: InputMaybe<ModelSubscriptionStringInput>;
  content?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionMessageFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionPostFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionPostFilterInput>>>;
  content?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionPostFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  title?: InputMaybe<ModelSubscriptionStringInput>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
  username?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionStringInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ModelSubscriptionUserFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionUserFilterInput>>>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  kontingentCurrent?: InputMaybe<ModelSubscriptionIntInput>;
  kontingentStartDate?: InputMaybe<ModelSubscriptionIntInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionUserFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
  userId?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelUserConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  kontingentCurrent?: InputMaybe<ModelIntInput>;
  kontingentStartDate?: InputMaybe<ModelIntInput>;
  not?: InputMaybe<ModelUserConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserConditionInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelStringInput>;
};

export type ModelUserConnection = {
  __typename?: 'ModelUserConnection';
  items: Array<Maybe<User>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelUserFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  kontingentCurrent?: InputMaybe<ModelIntInput>;
  kontingentStartDate?: InputMaybe<ModelIntInput>;
  not?: InputMaybe<ModelUserFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserFilterInput>>>;
  owner?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelStringInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  checkThenCreateEc2Config?: Maybe<Ec2Config>;
  createEc2Config?: Maybe<Ec2Config>;
  createLabDetail?: Maybe<LabDetail>;
  createLabDetailHistory?: Maybe<LabDetailHistory>;
  createMessage?: Maybe<Message>;
  createPost?: Maybe<Post>;
  createUser?: Maybe<User>;
  deleteEc2Config?: Maybe<Ec2Config>;
  deleteLabDetail?: Maybe<LabDetail>;
  deleteLabDetailHistory?: Maybe<LabDetailHistory>;
  deleteMessage?: Maybe<Message>;
  deletePost?: Maybe<Post>;
  deleteUser?: Maybe<User>;
  updateEc2Config?: Maybe<Ec2Config>;
  updateLabDetail?: Maybe<LabDetail>;
  updateLabDetailHistory?: Maybe<LabDetailHistory>;
  updateMessage?: Maybe<Message>;
  updatePost?: Maybe<Post>;
  updateUser?: Maybe<User>;
};

export type MutationCheckThenCreateEc2ConfigArgs = {
  input: CheckThenCreateEc2ConfigInput;
};

export type MutationCreateEc2ConfigArgs = {
  condition?: InputMaybe<ModelEc2ConfigConditionInput>;
  input: CreateEc2ConfigInput;
};

export type MutationCreateLabDetailArgs = {
  condition?: InputMaybe<ModelLabDetailConditionInput>;
  input: CreateLabDetailInput;
};

export type MutationCreateLabDetailHistoryArgs = {
  condition?: InputMaybe<ModelLabDetailHistoryConditionInput>;
  input: CreateLabDetailHistoryInput;
};

export type MutationCreateMessageArgs = {
  condition?: InputMaybe<ModelMessageConditionInput>;
  input: CreateMessageInput;
};

export type MutationCreatePostArgs = {
  condition?: InputMaybe<ModelPostConditionInput>;
  input: CreatePostInput;
};

export type MutationCreateUserArgs = {
  condition?: InputMaybe<ModelUserConditionInput>;
  input: CreateUserInput;
};

export type MutationDeleteEc2ConfigArgs = {
  condition?: InputMaybe<ModelEc2ConfigConditionInput>;
  input: DeleteEc2ConfigInput;
};

export type MutationDeleteLabDetailArgs = {
  condition?: InputMaybe<ModelLabDetailConditionInput>;
  input: DeleteLabDetailInput;
};

export type MutationDeleteLabDetailHistoryArgs = {
  condition?: InputMaybe<ModelLabDetailHistoryConditionInput>;
  input: DeleteLabDetailHistoryInput;
};

export type MutationDeleteMessageArgs = {
  condition?: InputMaybe<ModelMessageConditionInput>;
  input: DeleteMessageInput;
};

export type MutationDeletePostArgs = {
  condition?: InputMaybe<ModelPostConditionInput>;
  input: DeletePostInput;
};

export type MutationDeleteUserArgs = {
  condition?: InputMaybe<ModelUserConditionInput>;
  input: DeleteUserInput;
};

export type MutationUpdateEc2ConfigArgs = {
  condition?: InputMaybe<ModelEc2ConfigConditionInput>;
  input: UpdateEc2ConfigInput;
};

export type MutationUpdateLabDetailArgs = {
  condition?: InputMaybe<ModelLabDetailConditionInput>;
  input: UpdateLabDetailInput;
};

export type MutationUpdateLabDetailHistoryArgs = {
  condition?: InputMaybe<ModelLabDetailHistoryConditionInput>;
  input: UpdateLabDetailHistoryInput;
};

export type MutationUpdateMessageArgs = {
  condition?: InputMaybe<ModelMessageConditionInput>;
  input: UpdateMessageInput;
};

export type MutationUpdatePostArgs = {
  condition?: InputMaybe<ModelPostConditionInput>;
  input: UpdatePostInput;
};

export type MutationUpdateUserArgs = {
  condition?: InputMaybe<ModelUserConditionInput>;
  input: UpdateUserInput;
};

export type Post = {
  __typename?: 'Post';
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  username: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  getEc2Config?: Maybe<Ec2Config>;
  getLabDetail?: Maybe<LabDetail>;
  getLabDetailHistory?: Maybe<LabDetailHistory>;
  getMessage?: Maybe<Message>;
  getPost?: Maybe<Post>;
  getTodo?: Maybe<Todo>;
  getUser?: Maybe<User>;
  listEc2?: Maybe<Array<Maybe<Ec2>>>;
  listEc2Configs?: Maybe<ModelEc2ConfigConnection>;
  listLabDetailHistories?: Maybe<ModelLabDetailHistoryConnection>;
  listLabDetails?: Maybe<ModelLabDetailConnection>;
  listMessages?: Maybe<ModelMessageConnection>;
  listPosts?: Maybe<ModelPostConnection>;
  listTodos?: Maybe<Array<Maybe<Todo>>>;
  listUsers?: Maybe<ModelUserConnection>;
};

export type QueryGetEc2ConfigArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetLabDetailArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetLabDetailHistoryArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetMessageArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetPostArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetTodoArgs = {
  params: QueryGetTodoParamsInput;
};

export type QueryGetUserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryListEc2ConfigsArgs = {
  filter?: InputMaybe<ModelEc2ConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListLabDetailHistoriesArgs = {
  filter?: InputMaybe<ModelLabDetailHistoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListLabDetailsArgs = {
  filter?: InputMaybe<ModelLabDetailFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListMessagesArgs = {
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListPostsArgs = {
  filter?: InputMaybe<ModelPostFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListUsersArgs = {
  filter?: InputMaybe<ModelUserFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetTodoParamsInput = {
  id: Scalars['String']['input'];
};

export enum State {
  Pending = 'PENDING',
  Running = 'RUNNING',
  ShuttingDown = 'SHUTTING_DOWN',
  Stopped = 'STOPPED',
  Stopping = 'STOPPING',
  Terminated = 'TERMINATED',
  Unkown = 'UNKOWN',
}

export type Subscription = {
  __typename?: 'Subscription';
  onCreateEc2Config?: Maybe<Ec2Config>;
  onCreateLabDetail?: Maybe<LabDetail>;
  onCreateLabDetailHistory?: Maybe<LabDetailHistory>;
  onCreateMessage?: Maybe<Message>;
  onCreatePost?: Maybe<Post>;
  onCreateUser?: Maybe<User>;
  onDeleteEc2Config?: Maybe<Ec2Config>;
  onDeleteLabDetail?: Maybe<LabDetail>;
  onDeleteLabDetailHistory?: Maybe<LabDetailHistory>;
  onDeleteMessage?: Maybe<Message>;
  onDeletePost?: Maybe<Post>;
  onDeleteUser?: Maybe<User>;
  onUpdateEc2Config?: Maybe<Ec2Config>;
  onUpdateLabDetail?: Maybe<LabDetail>;
  onUpdateLabDetailHistory?: Maybe<LabDetailHistory>;
  onUpdateMessage?: Maybe<Message>;
  onUpdatePost?: Maybe<Post>;
  onUpdateUser?: Maybe<User>;
};

export type SubscriptionOnCreateEc2ConfigArgs = {
  filter?: InputMaybe<ModelSubscriptionEc2ConfigFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnCreateLabDetailArgs = {
  filter?: InputMaybe<ModelSubscriptionLabDetailFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnCreateLabDetailHistoryArgs = {
  filter?: InputMaybe<ModelSubscriptionLabDetailHistoryFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnCreateMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionMessageFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnCreatePostArgs = {
  filter?: InputMaybe<ModelSubscriptionPostFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnCreateUserArgs = {
  filter?: InputMaybe<ModelSubscriptionUserFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnDeleteEc2ConfigArgs = {
  filter?: InputMaybe<ModelSubscriptionEc2ConfigFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnDeleteLabDetailArgs = {
  filter?: InputMaybe<ModelSubscriptionLabDetailFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnDeleteLabDetailHistoryArgs = {
  filter?: InputMaybe<ModelSubscriptionLabDetailHistoryFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnDeleteMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionMessageFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnDeletePostArgs = {
  filter?: InputMaybe<ModelSubscriptionPostFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnDeleteUserArgs = {
  filter?: InputMaybe<ModelSubscriptionUserFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnUpdateEc2ConfigArgs = {
  filter?: InputMaybe<ModelSubscriptionEc2ConfigFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnUpdateLabDetailArgs = {
  filter?: InputMaybe<ModelSubscriptionLabDetailFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnUpdateLabDetailHistoryArgs = {
  filter?: InputMaybe<ModelSubscriptionLabDetailHistoryFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnUpdateMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionMessageFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnUpdatePostArgs = {
  filter?: InputMaybe<ModelSubscriptionPostFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type SubscriptionOnUpdateUserArgs = {
  filter?: InputMaybe<ModelSubscriptionUserFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type Todo = {
  __typename?: 'Todo';
  completed: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  userId: Scalars['Int']['output'];
};

export type UpdateEc2ConfigInput = {
  finished?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  lab?: InputMaybe<Lab>;
  labStatus?: InputMaybe<LabStatus>;
  simulateCreationError?: InputMaybe<Scalars['Boolean']['input']>;
  skipCfn?: InputMaybe<Scalars['Boolean']['input']>;
  terminateTimestamp?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLabDetailHistoryInput = {
  creationTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  durationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  labDetailHistoryId?: InputMaybe<Scalars['ID']['input']>;
  timeEnded?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  timeStarted?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  ttl?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLabDetailInput = {
  id: Scalars['ID']['input'];
  lab?: InputMaybe<Lab>;
  lastCreationTimeInSeconds?: InputMaybe<Scalars['Int']['input']>;
  lastDurationInSeconds?: InputMaybe<Scalars['Int']['input']>;
  lastTimeEnded?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  lastTimeStarted?: InputMaybe<Scalars['AWSTimestamp']['input']>;
};

export type UpdateMessageInput = {
  authorId?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type UpdatePostInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  id: Scalars['ID']['input'];
  kontingentCurrent?: InputMaybe<Scalars['Int']['input']>;
  kontingentStartDate?: InputMaybe<Scalars['AWSTimestamp']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  kontingentCurrent: Scalars['Int']['output'];
  kontingentStartDate: Scalars['AWSTimestamp']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['String']['output'];
};

export type CheckThenCreateEc2ConfigMutationVariables = Exact<{
  input: CheckThenCreateEc2ConfigInput;
}>;

export type CheckThenCreateEc2ConfigMutation = {
  __typename?: 'Mutation';
  checkThenCreateEc2Config?:
    | {
        __typename?: 'Ec2Config';
        id: string;
        skipCfn: boolean;
        simulateCreationError?: boolean | null | undefined;
        terminateTimestamp: any;
        userId: string;
        lab: Lab;
        finished?: boolean | null | undefined;
        labStatus?: LabStatus | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type CreateEc2ConfigMutationVariables = Exact<{
  input: CreateEc2ConfigInput;
  condition?: InputMaybe<ModelEc2ConfigConditionInput>;
}>;

export type CreateEc2ConfigMutation = {
  __typename?: 'Mutation';
  createEc2Config?:
    | {
        __typename?: 'Ec2Config';
        id: string;
        skipCfn: boolean;
        simulateCreationError?: boolean | null | undefined;
        terminateTimestamp: any;
        userId: string;
        lab: Lab;
        finished?: boolean | null | undefined;
        labStatus?: LabStatus | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type UpdateEc2ConfigMutationVariables = Exact<{
  input: UpdateEc2ConfigInput;
  condition?: InputMaybe<ModelEc2ConfigConditionInput>;
}>;

export type UpdateEc2ConfigMutation = {
  __typename?: 'Mutation';
  updateEc2Config?:
    | {
        __typename?: 'Ec2Config';
        id: string;
        skipCfn: boolean;
        simulateCreationError?: boolean | null | undefined;
        terminateTimestamp: any;
        userId: string;
        lab: Lab;
        finished?: boolean | null | undefined;
        labStatus?: LabStatus | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type DeleteEc2ConfigMutationVariables = Exact<{
  input: DeleteEc2ConfigInput;
  condition?: InputMaybe<ModelEc2ConfigConditionInput>;
}>;

export type DeleteEc2ConfigMutation = {
  __typename?: 'Mutation';
  deleteEc2Config?:
    | {
        __typename?: 'Ec2Config';
        id: string;
        skipCfn: boolean;
        simulateCreationError?: boolean | null | undefined;
        terminateTimestamp: any;
        userId: string;
        lab: Lab;
        finished?: boolean | null | undefined;
        labStatus?: LabStatus | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type CreateLabDetailMutationVariables = Exact<{
  input: CreateLabDetailInput;
  condition?: InputMaybe<ModelLabDetailConditionInput>;
}>;

export type CreateLabDetailMutation = {
  __typename?: 'Mutation';
  createLabDetail?:
    | {
        __typename?: 'LabDetail';
        id: string;
        lab: Lab;
        lastCreationTimeInSeconds?: number | null | undefined;
        lastDurationInSeconds?: number | null | undefined;
        lastTimeStarted?: any | null | undefined;
        lastTimeEnded?: any | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
        history?:
          | {
              __typename?: 'ModelLabDetailHistoryConnection';
              nextToken?: string | null | undefined;
              items: Array<
                | {
                    __typename?: 'LabDetailHistory';
                    id: string;
                    userId: string;
                    creationTimeInSeconds?: number | null | undefined;
                    durationInSeconds?: number | null | undefined;
                    timeStarted?: any | null | undefined;
                    timeEnded?: any | null | undefined;
                    ttl: any;
                    createdAt: any;
                    updatedAt: any;
                    labDetailHistoryId?: string | null | undefined;
                    owner?: string | null | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type UpdateLabDetailMutationVariables = Exact<{
  input: UpdateLabDetailInput;
  condition?: InputMaybe<ModelLabDetailConditionInput>;
}>;

export type UpdateLabDetailMutation = {
  __typename?: 'Mutation';
  updateLabDetail?:
    | {
        __typename?: 'LabDetail';
        id: string;
        lab: Lab;
        lastCreationTimeInSeconds?: number | null | undefined;
        lastDurationInSeconds?: number | null | undefined;
        lastTimeStarted?: any | null | undefined;
        lastTimeEnded?: any | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
        history?:
          | {
              __typename?: 'ModelLabDetailHistoryConnection';
              nextToken?: string | null | undefined;
              items: Array<
                | {
                    __typename?: 'LabDetailHistory';
                    id: string;
                    userId: string;
                    creationTimeInSeconds?: number | null | undefined;
                    durationInSeconds?: number | null | undefined;
                    timeStarted?: any | null | undefined;
                    timeEnded?: any | null | undefined;
                    ttl: any;
                    createdAt: any;
                    updatedAt: any;
                    labDetailHistoryId?: string | null | undefined;
                    owner?: string | null | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type DeleteLabDetailMutationVariables = Exact<{
  input: DeleteLabDetailInput;
  condition?: InputMaybe<ModelLabDetailConditionInput>;
}>;

export type DeleteLabDetailMutation = {
  __typename?: 'Mutation';
  deleteLabDetail?:
    | {
        __typename?: 'LabDetail';
        id: string;
        lab: Lab;
        lastCreationTimeInSeconds?: number | null | undefined;
        lastDurationInSeconds?: number | null | undefined;
        lastTimeStarted?: any | null | undefined;
        lastTimeEnded?: any | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
        history?:
          | {
              __typename?: 'ModelLabDetailHistoryConnection';
              nextToken?: string | null | undefined;
              items: Array<
                | {
                    __typename?: 'LabDetailHistory';
                    id: string;
                    userId: string;
                    creationTimeInSeconds?: number | null | undefined;
                    durationInSeconds?: number | null | undefined;
                    timeStarted?: any | null | undefined;
                    timeEnded?: any | null | undefined;
                    ttl: any;
                    createdAt: any;
                    updatedAt: any;
                    labDetailHistoryId?: string | null | undefined;
                    owner?: string | null | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type CreateLabDetailHistoryMutationVariables = Exact<{
  input: CreateLabDetailHistoryInput;
  condition?: InputMaybe<ModelLabDetailHistoryConditionInput>;
}>;

export type CreateLabDetailHistoryMutation = {
  __typename?: 'Mutation';
  createLabDetailHistory?:
    | {
        __typename?: 'LabDetailHistory';
        id: string;
        userId: string;
        creationTimeInSeconds?: number | null | undefined;
        durationInSeconds?: number | null | undefined;
        timeStarted?: any | null | undefined;
        timeEnded?: any | null | undefined;
        ttl: any;
        createdAt: any;
        updatedAt: any;
        labDetailHistoryId?: string | null | undefined;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type UpdateLabDetailHistoryMutationVariables = Exact<{
  input: UpdateLabDetailHistoryInput;
  condition?: InputMaybe<ModelLabDetailHistoryConditionInput>;
}>;

export type UpdateLabDetailHistoryMutation = {
  __typename?: 'Mutation';
  updateLabDetailHistory?:
    | {
        __typename?: 'LabDetailHistory';
        id: string;
        userId: string;
        creationTimeInSeconds?: number | null | undefined;
        durationInSeconds?: number | null | undefined;
        timeStarted?: any | null | undefined;
        timeEnded?: any | null | undefined;
        ttl: any;
        createdAt: any;
        updatedAt: any;
        labDetailHistoryId?: string | null | undefined;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type DeleteLabDetailHistoryMutationVariables = Exact<{
  input: DeleteLabDetailHistoryInput;
  condition?: InputMaybe<ModelLabDetailHistoryConditionInput>;
}>;

export type DeleteLabDetailHistoryMutation = {
  __typename?: 'Mutation';
  deleteLabDetailHistory?:
    | {
        __typename?: 'LabDetailHistory';
        id: string;
        userId: string;
        creationTimeInSeconds?: number | null | undefined;
        durationInSeconds?: number | null | undefined;
        timeStarted?: any | null | undefined;
        timeEnded?: any | null | undefined;
        ttl: any;
        createdAt: any;
        updatedAt: any;
        labDetailHistoryId?: string | null | undefined;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
  condition?: InputMaybe<ModelUserConditionInput>;
}>;

export type CreateUserMutation = {
  __typename?: 'Mutation';
  createUser?:
    | {
        __typename?: 'User';
        id: string;
        kontingentCurrent: number;
        kontingentStartDate: any;
        userId: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
  condition?: InputMaybe<ModelUserConditionInput>;
}>;

export type UpdateUserMutation = {
  __typename?: 'Mutation';
  updateUser?:
    | {
        __typename?: 'User';
        id: string;
        kontingentCurrent: number;
        kontingentStartDate: any;
        userId: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type DeleteUserMutationVariables = Exact<{
  input: DeleteUserInput;
  condition?: InputMaybe<ModelUserConditionInput>;
}>;

export type DeleteUserMutation = {
  __typename?: 'Mutation';
  deleteUser?:
    | {
        __typename?: 'User';
        id: string;
        kontingentCurrent: number;
        kontingentStartDate: any;
        userId: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type CreatePostMutationVariables = Exact<{
  input: CreatePostInput;
  condition?: InputMaybe<ModelPostConditionInput>;
}>;

export type CreatePostMutation = {
  __typename?: 'Mutation';
  createPost?:
    | {
        __typename?: 'Post';
        id: string;
        title: string;
        content: string;
        username: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type UpdatePostMutationVariables = Exact<{
  input: UpdatePostInput;
  condition?: InputMaybe<ModelPostConditionInput>;
}>;

export type UpdatePostMutation = {
  __typename?: 'Mutation';
  updatePost?:
    | {
        __typename?: 'Post';
        id: string;
        title: string;
        content: string;
        username: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type DeletePostMutationVariables = Exact<{
  input: DeletePostInput;
  condition?: InputMaybe<ModelPostConditionInput>;
}>;

export type DeletePostMutation = {
  __typename?: 'Mutation';
  deletePost?:
    | {
        __typename?: 'Post';
        id: string;
        title: string;
        content: string;
        username: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
  condition?: InputMaybe<ModelMessageConditionInput>;
}>;

export type CreateMessageMutation = {
  __typename?: 'Mutation';
  createMessage?:
    | {
        __typename?: 'Message';
        id: string;
        authorId: string;
        content: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type UpdateMessageMutationVariables = Exact<{
  input: UpdateMessageInput;
  condition?: InputMaybe<ModelMessageConditionInput>;
}>;

export type UpdateMessageMutation = {
  __typename?: 'Mutation';
  updateMessage?:
    | {
        __typename?: 'Message';
        id: string;
        authorId: string;
        content: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type DeleteMessageMutationVariables = Exact<{
  input: DeleteMessageInput;
  condition?: InputMaybe<ModelMessageConditionInput>;
}>;

export type DeleteMessageMutation = {
  __typename?: 'Mutation';
  deleteMessage?:
    | {
        __typename?: 'Message';
        id: string;
        authorId: string;
        content: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type ListTodosQueryVariables = Exact<{ [key: string]: never }>;

export type ListTodosQuery = {
  __typename?: 'Query';
  listTodos?:
    | Array<
        | {
            __typename?: 'Todo';
            id: number;
            userId: number;
            title: string;
            completed: boolean;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type GetTodoQueryVariables = Exact<{
  params: QueryGetTodoParamsInput;
}>;

export type GetTodoQuery = {
  __typename?: 'Query';
  getTodo?:
    | {
        __typename?: 'Todo';
        id: number;
        userId: number;
        title: string;
        completed: boolean;
      }
    | null
    | undefined;
};

export type ListEc2QueryVariables = Exact<{ [key: string]: never }>;

export type ListEc2Query = {
  __typename?: 'Query';
  listEc2?:
    | Array<
        | {
            __typename?: 'Ec2';
            id: string;
            userId: string;
            lab: Lab;
            name: string;
            state: State;
            publicDnsName?: string | null | undefined;
            privateKey?: string | null | undefined;
            ovpnKey?: string | null | undefined;
          }
        | null
        | undefined
      >
    | null
    | undefined;
};

export type GetEc2ConfigQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetEc2ConfigQuery = {
  __typename?: 'Query';
  getEc2Config?:
    | {
        __typename?: 'Ec2Config';
        id: string;
        skipCfn: boolean;
        simulateCreationError?: boolean | null | undefined;
        terminateTimestamp: any;
        userId: string;
        lab: Lab;
        finished?: boolean | null | undefined;
        labStatus?: LabStatus | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type ListEc2ConfigsQueryVariables = Exact<{
  filter?: InputMaybe<ModelEc2ConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListEc2ConfigsQuery = {
  __typename?: 'Query';
  listEc2Configs?:
    | {
        __typename?: 'ModelEc2ConfigConnection';
        nextToken?: string | null | undefined;
        items: Array<
          | {
              __typename?: 'Ec2Config';
              id: string;
              skipCfn: boolean;
              simulateCreationError?: boolean | null | undefined;
              terminateTimestamp: any;
              userId: string;
              lab: Lab;
              finished?: boolean | null | undefined;
              labStatus?: LabStatus | null | undefined;
              createdAt: any;
              updatedAt: any;
              owner?: string | null | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type GetLabDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetLabDetailQuery = {
  __typename?: 'Query';
  getLabDetail?:
    | {
        __typename?: 'LabDetail';
        id: string;
        lab: Lab;
        lastCreationTimeInSeconds?: number | null | undefined;
        lastDurationInSeconds?: number | null | undefined;
        lastTimeStarted?: any | null | undefined;
        lastTimeEnded?: any | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
        history?:
          | {
              __typename?: 'ModelLabDetailHistoryConnection';
              nextToken?: string | null | undefined;
              items: Array<
                | {
                    __typename?: 'LabDetailHistory';
                    id: string;
                    userId: string;
                    creationTimeInSeconds?: number | null | undefined;
                    durationInSeconds?: number | null | undefined;
                    timeStarted?: any | null | undefined;
                    timeEnded?: any | null | undefined;
                    ttl: any;
                    createdAt: any;
                    updatedAt: any;
                    labDetailHistoryId?: string | null | undefined;
                    owner?: string | null | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ListLabDetailsQueryVariables = Exact<{
  filter?: InputMaybe<ModelLabDetailFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListLabDetailsQuery = {
  __typename?: 'Query';
  listLabDetails?:
    | {
        __typename?: 'ModelLabDetailConnection';
        nextToken?: string | null | undefined;
        items: Array<
          | {
              __typename?: 'LabDetail';
              id: string;
              lab: Lab;
              lastCreationTimeInSeconds?: number | null | undefined;
              lastDurationInSeconds?: number | null | undefined;
              lastTimeStarted?: any | null | undefined;
              lastTimeEnded?: any | null | undefined;
              createdAt: any;
              updatedAt: any;
              owner?: string | null | undefined;
              history?:
                | {
                    __typename?: 'ModelLabDetailHistoryConnection';
                    nextToken?: string | null | undefined;
                    items: Array<
                      | {
                          __typename?: 'LabDetailHistory';
                          id: string;
                          userId: string;
                          creationTimeInSeconds?: number | null | undefined;
                          durationInSeconds?: number | null | undefined;
                          timeStarted?: any | null | undefined;
                          timeEnded?: any | null | undefined;
                          ttl: any;
                          createdAt: any;
                          updatedAt: any;
                          labDetailHistoryId?: string | null | undefined;
                          owner?: string | null | undefined;
                        }
                      | null
                      | undefined
                    >;
                  }
                | null
                | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type GetLabDetailHistoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetLabDetailHistoryQuery = {
  __typename?: 'Query';
  getLabDetailHistory?:
    | {
        __typename?: 'LabDetailHistory';
        id: string;
        userId: string;
        creationTimeInSeconds?: number | null | undefined;
        durationInSeconds?: number | null | undefined;
        timeStarted?: any | null | undefined;
        timeEnded?: any | null | undefined;
        ttl: any;
        createdAt: any;
        updatedAt: any;
        labDetailHistoryId?: string | null | undefined;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type ListLabDetailHistoriesQueryVariables = Exact<{
  filter?: InputMaybe<ModelLabDetailHistoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListLabDetailHistoriesQuery = {
  __typename?: 'Query';
  listLabDetailHistories?:
    | {
        __typename?: 'ModelLabDetailHistoryConnection';
        nextToken?: string | null | undefined;
        items: Array<
          | {
              __typename?: 'LabDetailHistory';
              id: string;
              userId: string;
              creationTimeInSeconds?: number | null | undefined;
              durationInSeconds?: number | null | undefined;
              timeStarted?: any | null | undefined;
              timeEnded?: any | null | undefined;
              ttl: any;
              createdAt: any;
              updatedAt: any;
              labDetailHistoryId?: string | null | undefined;
              owner?: string | null | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetUserQuery = {
  __typename?: 'Query';
  getUser?:
    | {
        __typename?: 'User';
        id: string;
        kontingentCurrent: number;
        kontingentStartDate: any;
        userId: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type ListUsersQueryVariables = Exact<{
  filter?: InputMaybe<ModelUserFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListUsersQuery = {
  __typename?: 'Query';
  listUsers?:
    | {
        __typename?: 'ModelUserConnection';
        nextToken?: string | null | undefined;
        items: Array<
          | {
              __typename?: 'User';
              id: string;
              kontingentCurrent: number;
              kontingentStartDate: any;
              userId: string;
              createdAt: any;
              updatedAt: any;
              owner?: string | null | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type GetPostQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetPostQuery = {
  __typename?: 'Query';
  getPost?:
    | {
        __typename?: 'Post';
        id: string;
        title: string;
        content: string;
        username: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type ListPostsQueryVariables = Exact<{
  filter?: InputMaybe<ModelPostFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListPostsQuery = {
  __typename?: 'Query';
  listPosts?:
    | {
        __typename?: 'ModelPostConnection';
        nextToken?: string | null | undefined;
        items: Array<
          | {
              __typename?: 'Post';
              id: string;
              title: string;
              content: string;
              username: string;
              createdAt: any;
              updatedAt: any;
              owner?: string | null | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type GetMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetMessageQuery = {
  __typename?: 'Query';
  getMessage?:
    | {
        __typename?: 'Message';
        id: string;
        authorId: string;
        content: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type ListMessagesQueryVariables = Exact<{
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListMessagesQuery = {
  __typename?: 'Query';
  listMessages?:
    | {
        __typename?: 'ModelMessageConnection';
        nextToken?: string | null | undefined;
        items: Array<
          | {
              __typename?: 'Message';
              id: string;
              authorId: string;
              content: string;
              createdAt: any;
              updatedAt: any;
              owner?: string | null | undefined;
            }
          | null
          | undefined
        >;
      }
    | null
    | undefined;
};

export type OnCreateEc2ConfigSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionEc2ConfigFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnCreateEc2ConfigSubscription = {
  __typename?: 'Subscription';
  onCreateEc2Config?:
    | {
        __typename?: 'Ec2Config';
        id: string;
        skipCfn: boolean;
        simulateCreationError?: boolean | null | undefined;
        terminateTimestamp: any;
        userId: string;
        lab: Lab;
        finished?: boolean | null | undefined;
        labStatus?: LabStatus | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnUpdateEc2ConfigSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionEc2ConfigFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnUpdateEc2ConfigSubscription = {
  __typename?: 'Subscription';
  onUpdateEc2Config?:
    | {
        __typename?: 'Ec2Config';
        id: string;
        skipCfn: boolean;
        simulateCreationError?: boolean | null | undefined;
        terminateTimestamp: any;
        userId: string;
        lab: Lab;
        finished?: boolean | null | undefined;
        labStatus?: LabStatus | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnDeleteEc2ConfigSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionEc2ConfigFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnDeleteEc2ConfigSubscription = {
  __typename?: 'Subscription';
  onDeleteEc2Config?:
    | {
        __typename?: 'Ec2Config';
        id: string;
        skipCfn: boolean;
        simulateCreationError?: boolean | null | undefined;
        terminateTimestamp: any;
        userId: string;
        lab: Lab;
        finished?: boolean | null | undefined;
        labStatus?: LabStatus | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnCreateLabDetailSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionLabDetailFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnCreateLabDetailSubscription = {
  __typename?: 'Subscription';
  onCreateLabDetail?:
    | {
        __typename?: 'LabDetail';
        id: string;
        lab: Lab;
        lastCreationTimeInSeconds?: number | null | undefined;
        lastDurationInSeconds?: number | null | undefined;
        lastTimeStarted?: any | null | undefined;
        lastTimeEnded?: any | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
        history?:
          | {
              __typename?: 'ModelLabDetailHistoryConnection';
              nextToken?: string | null | undefined;
              items: Array<
                | {
                    __typename?: 'LabDetailHistory';
                    id: string;
                    userId: string;
                    creationTimeInSeconds?: number | null | undefined;
                    durationInSeconds?: number | null | undefined;
                    timeStarted?: any | null | undefined;
                    timeEnded?: any | null | undefined;
                    ttl: any;
                    createdAt: any;
                    updatedAt: any;
                    labDetailHistoryId?: string | null | undefined;
                    owner?: string | null | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type OnUpdateLabDetailSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionLabDetailFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnUpdateLabDetailSubscription = {
  __typename?: 'Subscription';
  onUpdateLabDetail?:
    | {
        __typename?: 'LabDetail';
        id: string;
        lab: Lab;
        lastCreationTimeInSeconds?: number | null | undefined;
        lastDurationInSeconds?: number | null | undefined;
        lastTimeStarted?: any | null | undefined;
        lastTimeEnded?: any | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
        history?:
          | {
              __typename?: 'ModelLabDetailHistoryConnection';
              nextToken?: string | null | undefined;
              items: Array<
                | {
                    __typename?: 'LabDetailHistory';
                    id: string;
                    userId: string;
                    creationTimeInSeconds?: number | null | undefined;
                    durationInSeconds?: number | null | undefined;
                    timeStarted?: any | null | undefined;
                    timeEnded?: any | null | undefined;
                    ttl: any;
                    createdAt: any;
                    updatedAt: any;
                    labDetailHistoryId?: string | null | undefined;
                    owner?: string | null | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type OnDeleteLabDetailSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionLabDetailFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnDeleteLabDetailSubscription = {
  __typename?: 'Subscription';
  onDeleteLabDetail?:
    | {
        __typename?: 'LabDetail';
        id: string;
        lab: Lab;
        lastCreationTimeInSeconds?: number | null | undefined;
        lastDurationInSeconds?: number | null | undefined;
        lastTimeStarted?: any | null | undefined;
        lastTimeEnded?: any | null | undefined;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
        history?:
          | {
              __typename?: 'ModelLabDetailHistoryConnection';
              nextToken?: string | null | undefined;
              items: Array<
                | {
                    __typename?: 'LabDetailHistory';
                    id: string;
                    userId: string;
                    creationTimeInSeconds?: number | null | undefined;
                    durationInSeconds?: number | null | undefined;
                    timeStarted?: any | null | undefined;
                    timeEnded?: any | null | undefined;
                    ttl: any;
                    createdAt: any;
                    updatedAt: any;
                    labDetailHistoryId?: string | null | undefined;
                    owner?: string | null | undefined;
                  }
                | null
                | undefined
              >;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type OnCreateLabDetailHistorySubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionLabDetailHistoryFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnCreateLabDetailHistorySubscription = {
  __typename?: 'Subscription';
  onCreateLabDetailHistory?:
    | {
        __typename?: 'LabDetailHistory';
        id: string;
        userId: string;
        creationTimeInSeconds?: number | null | undefined;
        durationInSeconds?: number | null | undefined;
        timeStarted?: any | null | undefined;
        timeEnded?: any | null | undefined;
        ttl: any;
        createdAt: any;
        updatedAt: any;
        labDetailHistoryId?: string | null | undefined;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnUpdateLabDetailHistorySubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionLabDetailHistoryFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnUpdateLabDetailHistorySubscription = {
  __typename?: 'Subscription';
  onUpdateLabDetailHistory?:
    | {
        __typename?: 'LabDetailHistory';
        id: string;
        userId: string;
        creationTimeInSeconds?: number | null | undefined;
        durationInSeconds?: number | null | undefined;
        timeStarted?: any | null | undefined;
        timeEnded?: any | null | undefined;
        ttl: any;
        createdAt: any;
        updatedAt: any;
        labDetailHistoryId?: string | null | undefined;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnDeleteLabDetailHistorySubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionLabDetailHistoryFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnDeleteLabDetailHistorySubscription = {
  __typename?: 'Subscription';
  onDeleteLabDetailHistory?:
    | {
        __typename?: 'LabDetailHistory';
        id: string;
        userId: string;
        creationTimeInSeconds?: number | null | undefined;
        durationInSeconds?: number | null | undefined;
        timeStarted?: any | null | undefined;
        timeEnded?: any | null | undefined;
        ttl: any;
        createdAt: any;
        updatedAt: any;
        labDetailHistoryId?: string | null | undefined;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnCreateUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionUserFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnCreateUserSubscription = {
  __typename?: 'Subscription';
  onCreateUser?:
    | {
        __typename?: 'User';
        id: string;
        kontingentCurrent: number;
        kontingentStartDate: any;
        userId: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnUpdateUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionUserFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnUpdateUserSubscription = {
  __typename?: 'Subscription';
  onUpdateUser?:
    | {
        __typename?: 'User';
        id: string;
        kontingentCurrent: number;
        kontingentStartDate: any;
        userId: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnDeleteUserSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionUserFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnDeleteUserSubscription = {
  __typename?: 'Subscription';
  onDeleteUser?:
    | {
        __typename?: 'User';
        id: string;
        kontingentCurrent: number;
        kontingentStartDate: any;
        userId: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnCreatePostSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionPostFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnCreatePostSubscription = {
  __typename?: 'Subscription';
  onCreatePost?:
    | {
        __typename?: 'Post';
        id: string;
        title: string;
        content: string;
        username: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnUpdatePostSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionPostFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnUpdatePostSubscription = {
  __typename?: 'Subscription';
  onUpdatePost?:
    | {
        __typename?: 'Post';
        id: string;
        title: string;
        content: string;
        username: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnDeletePostSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionPostFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnDeletePostSubscription = {
  __typename?: 'Subscription';
  onDeletePost?:
    | {
        __typename?: 'Post';
        id: string;
        title: string;
        content: string;
        username: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnCreateMessageSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionMessageFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnCreateMessageSubscription = {
  __typename?: 'Subscription';
  onCreateMessage?:
    | {
        __typename?: 'Message';
        id: string;
        authorId: string;
        content: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnUpdateMessageSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionMessageFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnUpdateMessageSubscription = {
  __typename?: 'Subscription';
  onUpdateMessage?:
    | {
        __typename?: 'Message';
        id: string;
        authorId: string;
        content: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export type OnDeleteMessageSubscriptionVariables = Exact<{
  filter?: InputMaybe<ModelSubscriptionMessageFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
}>;

export type OnDeleteMessageSubscription = {
  __typename?: 'Subscription';
  onDeleteMessage?:
    | {
        __typename?: 'Message';
        id: string;
        authorId: string;
        content: string;
        createdAt: any;
        updatedAt: any;
        owner?: string | null | undefined;
      }
    | null
    | undefined;
};

export const CheckThenCreateEc2ConfigDocument = `
    mutation CheckThenCreateEc2Config($input: CheckThenCreateEc2ConfigInput!) {
  checkThenCreateEc2Config(input: $input) {
    id
    skipCfn
    simulateCreationError
    terminateTimestamp
    userId
    lab
    finished
    labStatus
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useCheckThenCreateEc2ConfigMutation = <
  TError = unknown,
  TContext = unknown
>(
  options?: UseMutationOptions<
    CheckThenCreateEc2ConfigMutation,
    TError,
    CheckThenCreateEc2ConfigMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CheckThenCreateEc2ConfigMutation,
    TError,
    CheckThenCreateEc2ConfigMutationVariables,
    TContext
  >({
    mutationKey: ['CheckThenCreateEc2Config'],
    mutationFn: (variables?: CheckThenCreateEc2ConfigMutationVariables) =>
      amplifyFetcher<
        CheckThenCreateEc2ConfigMutation,
        CheckThenCreateEc2ConfigMutationVariables
      >(CheckThenCreateEc2ConfigDocument, variables)(),
    ...options,
  });
};

export const CreateEc2ConfigDocument = `
    mutation CreateEc2Config($input: CreateEc2ConfigInput!, $condition: ModelEc2ConfigConditionInput) {
  createEc2Config(input: $input, condition: $condition) {
    id
    skipCfn
    simulateCreationError
    terminateTimestamp
    userId
    lab
    finished
    labStatus
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useCreateEc2ConfigMutation = <
  TError = unknown,
  TContext = unknown
>(
  options?: UseMutationOptions<
    CreateEc2ConfigMutation,
    TError,
    CreateEc2ConfigMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateEc2ConfigMutation,
    TError,
    CreateEc2ConfigMutationVariables,
    TContext
  >({
    mutationKey: ['CreateEc2Config'],
    mutationFn: (variables?: CreateEc2ConfigMutationVariables) =>
      amplifyFetcher<CreateEc2ConfigMutation, CreateEc2ConfigMutationVariables>(
        CreateEc2ConfigDocument,
        variables,
      )(),
    ...options,
  });
};

export const UpdateEc2ConfigDocument = `
    mutation UpdateEc2Config($input: UpdateEc2ConfigInput!, $condition: ModelEc2ConfigConditionInput) {
  updateEc2Config(input: $input, condition: $condition) {
    id
    skipCfn
    simulateCreationError
    terminateTimestamp
    userId
    lab
    finished
    labStatus
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useUpdateEc2ConfigMutation = <
  TError = unknown,
  TContext = unknown
>(
  options?: UseMutationOptions<
    UpdateEc2ConfigMutation,
    TError,
    UpdateEc2ConfigMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateEc2ConfigMutation,
    TError,
    UpdateEc2ConfigMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateEc2Config'],
    mutationFn: (variables?: UpdateEc2ConfigMutationVariables) =>
      amplifyFetcher<UpdateEc2ConfigMutation, UpdateEc2ConfigMutationVariables>(
        UpdateEc2ConfigDocument,
        variables,
      )(),
    ...options,
  });
};

export const DeleteEc2ConfigDocument = `
    mutation DeleteEc2Config($input: DeleteEc2ConfigInput!, $condition: ModelEc2ConfigConditionInput) {
  deleteEc2Config(input: $input, condition: $condition) {
    id
    skipCfn
    simulateCreationError
    terminateTimestamp
    userId
    lab
    finished
    labStatus
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useDeleteEc2ConfigMutation = <
  TError = unknown,
  TContext = unknown
>(
  options?: UseMutationOptions<
    DeleteEc2ConfigMutation,
    TError,
    DeleteEc2ConfigMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteEc2ConfigMutation,
    TError,
    DeleteEc2ConfigMutationVariables,
    TContext
  >({
    mutationKey: ['DeleteEc2Config'],
    mutationFn: (variables?: DeleteEc2ConfigMutationVariables) =>
      amplifyFetcher<DeleteEc2ConfigMutation, DeleteEc2ConfigMutationVariables>(
        DeleteEc2ConfigDocument,
        variables,
      )(),
    ...options,
  });
};

export const CreateLabDetailDocument = `
    mutation CreateLabDetail($input: CreateLabDetailInput!, $condition: ModelLabDetailConditionInput) {
  createLabDetail(input: $input, condition: $condition) {
    id
    lab
    lastCreationTimeInSeconds
    lastDurationInSeconds
    lastTimeStarted
    lastTimeEnded
    history {
      items {
        id
        userId
        creationTimeInSeconds
        durationInSeconds
        timeStarted
        timeEnded
        ttl
        createdAt
        updatedAt
        labDetailHistoryId
        owner
      }
      nextToken
    }
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useCreateLabDetailMutation = <
  TError = unknown,
  TContext = unknown
>(
  options?: UseMutationOptions<
    CreateLabDetailMutation,
    TError,
    CreateLabDetailMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateLabDetailMutation,
    TError,
    CreateLabDetailMutationVariables,
    TContext
  >({
    mutationKey: ['CreateLabDetail'],
    mutationFn: (variables?: CreateLabDetailMutationVariables) =>
      amplifyFetcher<CreateLabDetailMutation, CreateLabDetailMutationVariables>(
        CreateLabDetailDocument,
        variables,
      )(),
    ...options,
  });
};

export const UpdateLabDetailDocument = `
    mutation UpdateLabDetail($input: UpdateLabDetailInput!, $condition: ModelLabDetailConditionInput) {
  updateLabDetail(input: $input, condition: $condition) {
    id
    lab
    lastCreationTimeInSeconds
    lastDurationInSeconds
    lastTimeStarted
    lastTimeEnded
    history {
      items {
        id
        userId
        creationTimeInSeconds
        durationInSeconds
        timeStarted
        timeEnded
        ttl
        createdAt
        updatedAt
        labDetailHistoryId
        owner
      }
      nextToken
    }
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useUpdateLabDetailMutation = <
  TError = unknown,
  TContext = unknown
>(
  options?: UseMutationOptions<
    UpdateLabDetailMutation,
    TError,
    UpdateLabDetailMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateLabDetailMutation,
    TError,
    UpdateLabDetailMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateLabDetail'],
    mutationFn: (variables?: UpdateLabDetailMutationVariables) =>
      amplifyFetcher<UpdateLabDetailMutation, UpdateLabDetailMutationVariables>(
        UpdateLabDetailDocument,
        variables,
      )(),
    ...options,
  });
};

export const DeleteLabDetailDocument = `
    mutation DeleteLabDetail($input: DeleteLabDetailInput!, $condition: ModelLabDetailConditionInput) {
  deleteLabDetail(input: $input, condition: $condition) {
    id
    lab
    lastCreationTimeInSeconds
    lastDurationInSeconds
    lastTimeStarted
    lastTimeEnded
    history {
      items {
        id
        userId
        creationTimeInSeconds
        durationInSeconds
        timeStarted
        timeEnded
        ttl
        createdAt
        updatedAt
        labDetailHistoryId
        owner
      }
      nextToken
    }
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useDeleteLabDetailMutation = <
  TError = unknown,
  TContext = unknown
>(
  options?: UseMutationOptions<
    DeleteLabDetailMutation,
    TError,
    DeleteLabDetailMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteLabDetailMutation,
    TError,
    DeleteLabDetailMutationVariables,
    TContext
  >({
    mutationKey: ['DeleteLabDetail'],
    mutationFn: (variables?: DeleteLabDetailMutationVariables) =>
      amplifyFetcher<DeleteLabDetailMutation, DeleteLabDetailMutationVariables>(
        DeleteLabDetailDocument,
        variables,
      )(),
    ...options,
  });
};

export const CreateLabDetailHistoryDocument = `
    mutation CreateLabDetailHistory($input: CreateLabDetailHistoryInput!, $condition: ModelLabDetailHistoryConditionInput) {
  createLabDetailHistory(input: $input, condition: $condition) {
    id
    userId
    creationTimeInSeconds
    durationInSeconds
    timeStarted
    timeEnded
    ttl
    createdAt
    updatedAt
    labDetailHistoryId
    owner
  }
}
    `;

export const useCreateLabDetailHistoryMutation = <
  TError = unknown,
  TContext = unknown
>(
  options?: UseMutationOptions<
    CreateLabDetailHistoryMutation,
    TError,
    CreateLabDetailHistoryMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateLabDetailHistoryMutation,
    TError,
    CreateLabDetailHistoryMutationVariables,
    TContext
  >({
    mutationKey: ['CreateLabDetailHistory'],
    mutationFn: (variables?: CreateLabDetailHistoryMutationVariables) =>
      amplifyFetcher<
        CreateLabDetailHistoryMutation,
        CreateLabDetailHistoryMutationVariables
      >(CreateLabDetailHistoryDocument, variables)(),
    ...options,
  });
};

export const UpdateLabDetailHistoryDocument = `
    mutation UpdateLabDetailHistory($input: UpdateLabDetailHistoryInput!, $condition: ModelLabDetailHistoryConditionInput) {
  updateLabDetailHistory(input: $input, condition: $condition) {
    id
    userId
    creationTimeInSeconds
    durationInSeconds
    timeStarted
    timeEnded
    ttl
    createdAt
    updatedAt
    labDetailHistoryId
    owner
  }
}
    `;

export const useUpdateLabDetailHistoryMutation = <
  TError = unknown,
  TContext = unknown
>(
  options?: UseMutationOptions<
    UpdateLabDetailHistoryMutation,
    TError,
    UpdateLabDetailHistoryMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateLabDetailHistoryMutation,
    TError,
    UpdateLabDetailHistoryMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateLabDetailHistory'],
    mutationFn: (variables?: UpdateLabDetailHistoryMutationVariables) =>
      amplifyFetcher<
        UpdateLabDetailHistoryMutation,
        UpdateLabDetailHistoryMutationVariables
      >(UpdateLabDetailHistoryDocument, variables)(),
    ...options,
  });
};

export const DeleteLabDetailHistoryDocument = `
    mutation DeleteLabDetailHistory($input: DeleteLabDetailHistoryInput!, $condition: ModelLabDetailHistoryConditionInput) {
  deleteLabDetailHistory(input: $input, condition: $condition) {
    id
    userId
    creationTimeInSeconds
    durationInSeconds
    timeStarted
    timeEnded
    ttl
    createdAt
    updatedAt
    labDetailHistoryId
    owner
  }
}
    `;

export const useDeleteLabDetailHistoryMutation = <
  TError = unknown,
  TContext = unknown
>(
  options?: UseMutationOptions<
    DeleteLabDetailHistoryMutation,
    TError,
    DeleteLabDetailHistoryMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteLabDetailHistoryMutation,
    TError,
    DeleteLabDetailHistoryMutationVariables,
    TContext
  >({
    mutationKey: ['DeleteLabDetailHistory'],
    mutationFn: (variables?: DeleteLabDetailHistoryMutationVariables) =>
      amplifyFetcher<
        DeleteLabDetailHistoryMutation,
        DeleteLabDetailHistoryMutationVariables
      >(DeleteLabDetailHistoryDocument, variables)(),
    ...options,
  });
};

export const CreateUserDocument = `
    mutation CreateUser($input: CreateUserInput!, $condition: ModelUserConditionInput) {
  createUser(input: $input, condition: $condition) {
    id
    kontingentCurrent
    kontingentStartDate
    userId
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useCreateUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateUserMutation,
    TError,
    CreateUserMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateUserMutation,
    TError,
    CreateUserMutationVariables,
    TContext
  >({
    mutationKey: ['CreateUser'],
    mutationFn: (variables?: CreateUserMutationVariables) =>
      amplifyFetcher<CreateUserMutation, CreateUserMutationVariables>(
        CreateUserDocument,
        variables,
      )(),
    ...options,
  });
};

export const UpdateUserDocument = `
    mutation UpdateUser($input: UpdateUserInput!, $condition: ModelUserConditionInput) {
  updateUser(input: $input, condition: $condition) {
    id
    kontingentCurrent
    kontingentStartDate
    userId
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useUpdateUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateUserMutation,
    TError,
    UpdateUserMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateUserMutation,
    TError,
    UpdateUserMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateUser'],
    mutationFn: (variables?: UpdateUserMutationVariables) =>
      amplifyFetcher<UpdateUserMutation, UpdateUserMutationVariables>(
        UpdateUserDocument,
        variables,
      )(),
    ...options,
  });
};

export const DeleteUserDocument = `
    mutation DeleteUser($input: DeleteUserInput!, $condition: ModelUserConditionInput) {
  deleteUser(input: $input, condition: $condition) {
    id
    kontingentCurrent
    kontingentStartDate
    userId
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useDeleteUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteUserMutation,
    TError,
    DeleteUserMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteUserMutation,
    TError,
    DeleteUserMutationVariables,
    TContext
  >({
    mutationKey: ['DeleteUser'],
    mutationFn: (variables?: DeleteUserMutationVariables) =>
      amplifyFetcher<DeleteUserMutation, DeleteUserMutationVariables>(
        DeleteUserDocument,
        variables,
      )(),
    ...options,
  });
};

export const CreatePostDocument = `
    mutation CreatePost($input: CreatePostInput!, $condition: ModelPostConditionInput) {
  createPost(input: $input, condition: $condition) {
    id
    title
    content
    username
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useCreatePostMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreatePostMutation,
    TError,
    CreatePostMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreatePostMutation,
    TError,
    CreatePostMutationVariables,
    TContext
  >({
    mutationKey: ['CreatePost'],
    mutationFn: (variables?: CreatePostMutationVariables) =>
      amplifyFetcher<CreatePostMutation, CreatePostMutationVariables>(
        CreatePostDocument,
        variables,
      )(),
    ...options,
  });
};

export const UpdatePostDocument = `
    mutation UpdatePost($input: UpdatePostInput!, $condition: ModelPostConditionInput) {
  updatePost(input: $input, condition: $condition) {
    id
    title
    content
    username
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useUpdatePostMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdatePostMutation,
    TError,
    UpdatePostMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdatePostMutation,
    TError,
    UpdatePostMutationVariables,
    TContext
  >({
    mutationKey: ['UpdatePost'],
    mutationFn: (variables?: UpdatePostMutationVariables) =>
      amplifyFetcher<UpdatePostMutation, UpdatePostMutationVariables>(
        UpdatePostDocument,
        variables,
      )(),
    ...options,
  });
};

export const DeletePostDocument = `
    mutation DeletePost($input: DeletePostInput!, $condition: ModelPostConditionInput) {
  deletePost(input: $input, condition: $condition) {
    id
    title
    content
    username
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useDeletePostMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeletePostMutation,
    TError,
    DeletePostMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeletePostMutation,
    TError,
    DeletePostMutationVariables,
    TContext
  >({
    mutationKey: ['DeletePost'],
    mutationFn: (variables?: DeletePostMutationVariables) =>
      amplifyFetcher<DeletePostMutation, DeletePostMutationVariables>(
        DeletePostDocument,
        variables,
      )(),
    ...options,
  });
};

export const CreateMessageDocument = `
    mutation CreateMessage($input: CreateMessageInput!, $condition: ModelMessageConditionInput) {
  createMessage(input: $input, condition: $condition) {
    id
    authorId
    content
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useCreateMessageMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateMessageMutation,
    TError,
    CreateMessageMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    CreateMessageMutation,
    TError,
    CreateMessageMutationVariables,
    TContext
  >({
    mutationKey: ['CreateMessage'],
    mutationFn: (variables?: CreateMessageMutationVariables) =>
      amplifyFetcher<CreateMessageMutation, CreateMessageMutationVariables>(
        CreateMessageDocument,
        variables,
      )(),
    ...options,
  });
};

export const UpdateMessageDocument = `
    mutation UpdateMessage($input: UpdateMessageInput!, $condition: ModelMessageConditionInput) {
  updateMessage(input: $input, condition: $condition) {
    id
    authorId
    content
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useUpdateMessageMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateMessageMutation,
    TError,
    UpdateMessageMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    UpdateMessageMutation,
    TError,
    UpdateMessageMutationVariables,
    TContext
  >({
    mutationKey: ['UpdateMessage'],
    mutationFn: (variables?: UpdateMessageMutationVariables) =>
      amplifyFetcher<UpdateMessageMutation, UpdateMessageMutationVariables>(
        UpdateMessageDocument,
        variables,
      )(),
    ...options,
  });
};

export const DeleteMessageDocument = `
    mutation DeleteMessage($input: DeleteMessageInput!, $condition: ModelMessageConditionInput) {
  deleteMessage(input: $input, condition: $condition) {
    id
    authorId
    content
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useDeleteMessageMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteMessageMutation,
    TError,
    DeleteMessageMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    DeleteMessageMutation,
    TError,
    DeleteMessageMutationVariables,
    TContext
  >({
    mutationKey: ['DeleteMessage'],
    mutationFn: (variables?: DeleteMessageMutationVariables) =>
      amplifyFetcher<DeleteMessageMutation, DeleteMessageMutationVariables>(
        DeleteMessageDocument,
        variables,
      )(),
    ...options,
  });
};

export const ListTodosDocument = `
    query ListTodos {
  listTodos {
    id
    userId
    title
    completed
  }
}
    `;

export const useListTodosQuery = <TData = ListTodosQuery, TError = unknown>(
  variables?: ListTodosQueryVariables,
  options?: Omit<UseQueryOptions<ListTodosQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ListTodosQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ListTodosQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['ListTodos'] : ['ListTodos', variables],
    queryFn: amplifyFetcher<ListTodosQuery, ListTodosQueryVariables>(
      ListTodosDocument,
      variables,
    ),
    ...options,
  });
};

export const GetTodoDocument = `
    query GetTodo($params: QueryGetTodoParamsInput!) {
  getTodo(params: $params) {
    id
    userId
    title
    completed
  }
}
    `;

export const useGetTodoQuery = <TData = GetTodoQuery, TError = unknown>(
  variables: GetTodoQueryVariables,
  options?: Omit<UseQueryOptions<GetTodoQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetTodoQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<GetTodoQuery, TError, TData>({
    queryKey: ['GetTodo', variables],
    queryFn: amplifyFetcher<GetTodoQuery, GetTodoQueryVariables>(
      GetTodoDocument,
      variables,
    ),
    ...options,
  });
};

export const ListEc2Document = `
    query ListEc2 {
  listEc2 {
    id
    userId
    lab
    name
    state
    publicDnsName
    privateKey
    ovpnKey
  }
}
    `;

export const useListEc2Query = <TData = ListEc2Query, TError = unknown>(
  variables?: ListEc2QueryVariables,
  options?: Omit<UseQueryOptions<ListEc2Query, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ListEc2Query, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ListEc2Query, TError, TData>({
    queryKey: variables === undefined ? ['ListEc2'] : ['ListEc2', variables],
    queryFn: amplifyFetcher<ListEc2Query, ListEc2QueryVariables>(
      ListEc2Document,
      variables,
    ),
    ...options,
  });
};

export const GetEc2ConfigDocument = `
    query GetEc2Config($id: ID!) {
  getEc2Config(id: $id) {
    id
    skipCfn
    simulateCreationError
    terminateTimestamp
    userId
    lab
    finished
    labStatus
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useGetEc2ConfigQuery = <
  TData = GetEc2ConfigQuery,
  TError = unknown
>(
  variables: GetEc2ConfigQueryVariables,
  options?: Omit<
    UseQueryOptions<GetEc2ConfigQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<GetEc2ConfigQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<GetEc2ConfigQuery, TError, TData>({
    queryKey: ['GetEc2Config', variables],
    queryFn: amplifyFetcher<GetEc2ConfigQuery, GetEc2ConfigQueryVariables>(
      GetEc2ConfigDocument,
      variables,
    ),
    ...options,
  });
};

export const ListEc2ConfigsDocument = `
    query ListEc2Configs($filter: ModelEc2ConfigFilterInput, $limit: Int, $nextToken: String) {
  listEc2Configs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      skipCfn
      simulateCreationError
      terminateTimestamp
      userId
      lab
      finished
      labStatus
      createdAt
      updatedAt
      owner
    }
    nextToken
  }
}
    `;

export const useListEc2ConfigsQuery = <
  TData = ListEc2ConfigsQuery,
  TError = unknown
>(
  variables?: ListEc2ConfigsQueryVariables,
  options?: Omit<
    UseQueryOptions<ListEc2ConfigsQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<ListEc2ConfigsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ListEc2ConfigsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['ListEc2Configs']
        : ['ListEc2Configs', variables],
    queryFn: amplifyFetcher<ListEc2ConfigsQuery, ListEc2ConfigsQueryVariables>(
      ListEc2ConfigsDocument,
      variables,
    ),
    ...options,
  });
};

export const GetLabDetailDocument = `
    query GetLabDetail($id: ID!) {
  getLabDetail(id: $id) {
    id
    lab
    lastCreationTimeInSeconds
    lastDurationInSeconds
    lastTimeStarted
    lastTimeEnded
    history {
      items {
        id
        userId
        creationTimeInSeconds
        durationInSeconds
        timeStarted
        timeEnded
        ttl
        createdAt
        updatedAt
        labDetailHistoryId
        owner
      }
      nextToken
    }
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useGetLabDetailQuery = <
  TData = GetLabDetailQuery,
  TError = unknown
>(
  variables: GetLabDetailQueryVariables,
  options?: Omit<
    UseQueryOptions<GetLabDetailQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<GetLabDetailQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<GetLabDetailQuery, TError, TData>({
    queryKey: ['GetLabDetail', variables],
    queryFn: amplifyFetcher<GetLabDetailQuery, GetLabDetailQueryVariables>(
      GetLabDetailDocument,
      variables,
    ),
    ...options,
  });
};

export const ListLabDetailsDocument = `
    query ListLabDetails($filter: ModelLabDetailFilterInput, $limit: Int, $nextToken: String) {
  listLabDetails(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      lab
      lastCreationTimeInSeconds
      lastDurationInSeconds
      lastTimeStarted
      lastTimeEnded
      history {
        items {
          id
          userId
          creationTimeInSeconds
          durationInSeconds
          timeStarted
          timeEnded
          ttl
          createdAt
          updatedAt
          labDetailHistoryId
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
    nextToken
  }
}
    `;

export const useListLabDetailsQuery = <
  TData = ListLabDetailsQuery,
  TError = unknown
>(
  variables?: ListLabDetailsQueryVariables,
  options?: Omit<
    UseQueryOptions<ListLabDetailsQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<ListLabDetailsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ListLabDetailsQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['ListLabDetails']
        : ['ListLabDetails', variables],
    queryFn: amplifyFetcher<ListLabDetailsQuery, ListLabDetailsQueryVariables>(
      ListLabDetailsDocument,
      variables,
    ),
    ...options,
  });
};

export const GetLabDetailHistoryDocument = `
    query GetLabDetailHistory($id: ID!) {
  getLabDetailHistory(id: $id) {
    id
    userId
    creationTimeInSeconds
    durationInSeconds
    timeStarted
    timeEnded
    ttl
    createdAt
    updatedAt
    labDetailHistoryId
    owner
  }
}
    `;

export const useGetLabDetailHistoryQuery = <
  TData = GetLabDetailHistoryQuery,
  TError = unknown
>(
  variables: GetLabDetailHistoryQueryVariables,
  options?: Omit<
    UseQueryOptions<GetLabDetailHistoryQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      GetLabDetailHistoryQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useQuery<GetLabDetailHistoryQuery, TError, TData>({
    queryKey: ['GetLabDetailHistory', variables],
    queryFn: amplifyFetcher<
      GetLabDetailHistoryQuery,
      GetLabDetailHistoryQueryVariables
    >(GetLabDetailHistoryDocument, variables),
    ...options,
  });
};

export const ListLabDetailHistoriesDocument = `
    query ListLabDetailHistories($filter: ModelLabDetailHistoryFilterInput, $limit: Int, $nextToken: String) {
  listLabDetailHistories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userId
      creationTimeInSeconds
      durationInSeconds
      timeStarted
      timeEnded
      ttl
      createdAt
      updatedAt
      labDetailHistoryId
      owner
    }
    nextToken
  }
}
    `;

export const useListLabDetailHistoriesQuery = <
  TData = ListLabDetailHistoriesQuery,
  TError = unknown
>(
  variables?: ListLabDetailHistoriesQueryVariables,
  options?: Omit<
    UseQueryOptions<ListLabDetailHistoriesQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<
      ListLabDetailHistoriesQuery,
      TError,
      TData
    >['queryKey'];
  },
) => {
  return useQuery<ListLabDetailHistoriesQuery, TError, TData>({
    queryKey:
      variables === undefined
        ? ['ListLabDetailHistories']
        : ['ListLabDetailHistories', variables],
    queryFn: amplifyFetcher<
      ListLabDetailHistoriesQuery,
      ListLabDetailHistoriesQueryVariables
    >(ListLabDetailHistoriesDocument, variables),
    ...options,
  });
};

export const GetUserDocument = `
    query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    kontingentCurrent
    kontingentStartDate
    userId
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useGetUserQuery = <TData = GetUserQuery, TError = unknown>(
  variables: GetUserQueryVariables,
  options?: Omit<UseQueryOptions<GetUserQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetUserQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<GetUserQuery, TError, TData>({
    queryKey: ['GetUser', variables],
    queryFn: amplifyFetcher<GetUserQuery, GetUserQueryVariables>(
      GetUserDocument,
      variables,
    ),
    ...options,
  });
};

export const ListUsersDocument = `
    query ListUsers($filter: ModelUserFilterInput, $limit: Int, $nextToken: String) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      kontingentCurrent
      kontingentStartDate
      userId
      createdAt
      updatedAt
      owner
    }
    nextToken
  }
}
    `;

export const useListUsersQuery = <TData = ListUsersQuery, TError = unknown>(
  variables?: ListUsersQueryVariables,
  options?: Omit<UseQueryOptions<ListUsersQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ListUsersQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ListUsersQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['ListUsers'] : ['ListUsers', variables],
    queryFn: amplifyFetcher<ListUsersQuery, ListUsersQueryVariables>(
      ListUsersDocument,
      variables,
    ),
    ...options,
  });
};

export const GetPostDocument = `
    query GetPost($id: ID!) {
  getPost(id: $id) {
    id
    title
    content
    username
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useGetPostQuery = <TData = GetPostQuery, TError = unknown>(
  variables: GetPostQueryVariables,
  options?: Omit<UseQueryOptions<GetPostQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<GetPostQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<GetPostQuery, TError, TData>({
    queryKey: ['GetPost', variables],
    queryFn: amplifyFetcher<GetPostQuery, GetPostQueryVariables>(
      GetPostDocument,
      variables,
    ),
    ...options,
  });
};

export const ListPostsDocument = `
    query ListPosts($filter: ModelPostFilterInput, $limit: Int, $nextToken: String) {
  listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      title
      content
      username
      createdAt
      updatedAt
      owner
    }
    nextToken
  }
}
    `;

export const useListPostsQuery = <TData = ListPostsQuery, TError = unknown>(
  variables?: ListPostsQueryVariables,
  options?: Omit<UseQueryOptions<ListPostsQuery, TError, TData>, 'queryKey'> & {
    queryKey?: UseQueryOptions<ListPostsQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ListPostsQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['ListPosts'] : ['ListPosts', variables],
    queryFn: amplifyFetcher<ListPostsQuery, ListPostsQueryVariables>(
      ListPostsDocument,
      variables,
    ),
    ...options,
  });
};

export const GetMessageDocument = `
    query GetMessage($id: ID!) {
  getMessage(id: $id) {
    id
    authorId
    content
    createdAt
    updatedAt
    owner
  }
}
    `;

export const useGetMessageQuery = <TData = GetMessageQuery, TError = unknown>(
  variables: GetMessageQueryVariables,
  options?: Omit<
    UseQueryOptions<GetMessageQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<GetMessageQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<GetMessageQuery, TError, TData>({
    queryKey: ['GetMessage', variables],
    queryFn: amplifyFetcher<GetMessageQuery, GetMessageQueryVariables>(
      GetMessageDocument,
      variables,
    ),
    ...options,
  });
};

export const ListMessagesDocument = `
    query ListMessages($filter: ModelMessageFilterInput, $limit: Int, $nextToken: String) {
  listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      authorId
      content
      createdAt
      updatedAt
      owner
    }
    nextToken
  }
}
    `;

export const useListMessagesQuery = <
  TData = ListMessagesQuery,
  TError = unknown
>(
  variables?: ListMessagesQueryVariables,
  options?: Omit<
    UseQueryOptions<ListMessagesQuery, TError, TData>,
    'queryKey'
  > & {
    queryKey?: UseQueryOptions<ListMessagesQuery, TError, TData>['queryKey'];
  },
) => {
  return useQuery<ListMessagesQuery, TError, TData>({
    queryKey:
      variables === undefined ? ['ListMessages'] : ['ListMessages', variables],
    queryFn: amplifyFetcher<ListMessagesQuery, ListMessagesQueryVariables>(
      ListMessagesDocument,
      variables,
    ),
    ...options,
  });
};

export const OnCreateEc2ConfigDocument = `
    subscription OnCreateEc2Config($filter: ModelSubscriptionEc2ConfigFilterInput, $owner: String) {
  onCreateEc2Config(filter: $filter, owner: $owner) {
    id
    skipCfn
    simulateCreationError
    terminateTimestamp
    userId
    lab
    finished
    labStatus
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnUpdateEc2ConfigDocument = `
    subscription OnUpdateEc2Config($filter: ModelSubscriptionEc2ConfigFilterInput, $owner: String) {
  onUpdateEc2Config(filter: $filter, owner: $owner) {
    id
    skipCfn
    simulateCreationError
    terminateTimestamp
    userId
    lab
    finished
    labStatus
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnDeleteEc2ConfigDocument = `
    subscription OnDeleteEc2Config($filter: ModelSubscriptionEc2ConfigFilterInput, $owner: String) {
  onDeleteEc2Config(filter: $filter, owner: $owner) {
    id
    skipCfn
    simulateCreationError
    terminateTimestamp
    userId
    lab
    finished
    labStatus
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnCreateLabDetailDocument = `
    subscription OnCreateLabDetail($filter: ModelSubscriptionLabDetailFilterInput, $owner: String) {
  onCreateLabDetail(filter: $filter, owner: $owner) {
    id
    lab
    lastCreationTimeInSeconds
    lastDurationInSeconds
    lastTimeStarted
    lastTimeEnded
    history {
      items {
        id
        userId
        creationTimeInSeconds
        durationInSeconds
        timeStarted
        timeEnded
        ttl
        createdAt
        updatedAt
        labDetailHistoryId
        owner
      }
      nextToken
    }
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnUpdateLabDetailDocument = `
    subscription OnUpdateLabDetail($filter: ModelSubscriptionLabDetailFilterInput, $owner: String) {
  onUpdateLabDetail(filter: $filter, owner: $owner) {
    id
    lab
    lastCreationTimeInSeconds
    lastDurationInSeconds
    lastTimeStarted
    lastTimeEnded
    history {
      items {
        id
        userId
        creationTimeInSeconds
        durationInSeconds
        timeStarted
        timeEnded
        ttl
        createdAt
        updatedAt
        labDetailHistoryId
        owner
      }
      nextToken
    }
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnDeleteLabDetailDocument = `
    subscription OnDeleteLabDetail($filter: ModelSubscriptionLabDetailFilterInput, $owner: String) {
  onDeleteLabDetail(filter: $filter, owner: $owner) {
    id
    lab
    lastCreationTimeInSeconds
    lastDurationInSeconds
    lastTimeStarted
    lastTimeEnded
    history {
      items {
        id
        userId
        creationTimeInSeconds
        durationInSeconds
        timeStarted
        timeEnded
        ttl
        createdAt
        updatedAt
        labDetailHistoryId
        owner
      }
      nextToken
    }
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnCreateLabDetailHistoryDocument = `
    subscription OnCreateLabDetailHistory($filter: ModelSubscriptionLabDetailHistoryFilterInput, $owner: String) {
  onCreateLabDetailHistory(filter: $filter, owner: $owner) {
    id
    userId
    creationTimeInSeconds
    durationInSeconds
    timeStarted
    timeEnded
    ttl
    createdAt
    updatedAt
    labDetailHistoryId
    owner
  }
}
    `;
export const OnUpdateLabDetailHistoryDocument = `
    subscription OnUpdateLabDetailHistory($filter: ModelSubscriptionLabDetailHistoryFilterInput, $owner: String) {
  onUpdateLabDetailHistory(filter: $filter, owner: $owner) {
    id
    userId
    creationTimeInSeconds
    durationInSeconds
    timeStarted
    timeEnded
    ttl
    createdAt
    updatedAt
    labDetailHistoryId
    owner
  }
}
    `;
export const OnDeleteLabDetailHistoryDocument = `
    subscription OnDeleteLabDetailHistory($filter: ModelSubscriptionLabDetailHistoryFilterInput, $owner: String) {
  onDeleteLabDetailHistory(filter: $filter, owner: $owner) {
    id
    userId
    creationTimeInSeconds
    durationInSeconds
    timeStarted
    timeEnded
    ttl
    createdAt
    updatedAt
    labDetailHistoryId
    owner
  }
}
    `;
export const OnCreateUserDocument = `
    subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput, $owner: String) {
  onCreateUser(filter: $filter, owner: $owner) {
    id
    kontingentCurrent
    kontingentStartDate
    userId
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnUpdateUserDocument = `
    subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput, $owner: String) {
  onUpdateUser(filter: $filter, owner: $owner) {
    id
    kontingentCurrent
    kontingentStartDate
    userId
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnDeleteUserDocument = `
    subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput, $owner: String) {
  onDeleteUser(filter: $filter, owner: $owner) {
    id
    kontingentCurrent
    kontingentStartDate
    userId
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnCreatePostDocument = `
    subscription OnCreatePost($filter: ModelSubscriptionPostFilterInput, $owner: String) {
  onCreatePost(filter: $filter, owner: $owner) {
    id
    title
    content
    username
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnUpdatePostDocument = `
    subscription OnUpdatePost($filter: ModelSubscriptionPostFilterInput, $owner: String) {
  onUpdatePost(filter: $filter, owner: $owner) {
    id
    title
    content
    username
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnDeletePostDocument = `
    subscription OnDeletePost($filter: ModelSubscriptionPostFilterInput, $owner: String) {
  onDeletePost(filter: $filter, owner: $owner) {
    id
    title
    content
    username
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnCreateMessageDocument = `
    subscription OnCreateMessage($filter: ModelSubscriptionMessageFilterInput, $owner: String) {
  onCreateMessage(filter: $filter, owner: $owner) {
    id
    authorId
    content
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnUpdateMessageDocument = `
    subscription OnUpdateMessage($filter: ModelSubscriptionMessageFilterInput, $owner: String) {
  onUpdateMessage(filter: $filter, owner: $owner) {
    id
    authorId
    content
    createdAt
    updatedAt
    owner
  }
}
    `;
export const OnDeleteMessageDocument = `
    subscription OnDeleteMessage($filter: ModelSubscriptionMessageFilterInput, $owner: String) {
  onDeleteMessage(filter: $filter, owner: $owner) {
    id
    authorId
    content
    createdAt
    updatedAt
    owner
  }
}
    `;
